module.exports = __webpack_public_path__ + "static/top-technologies-implemented-24ffd7d368430edc327bd70eab06abd2.svg";